import React, { Component } from 'react';
import { observer } from 'mobx-react';
import { Flex, FlexColumn, Icon, Switch } from 'core/components';
import AdminTable from 'app/components/admin/AdminTable';
import { Search } from 'core/components/table';
import { policyStatusRenderer } from 'app/views/alerting/policies/commonRenderers';

const SHOW_SELECTED_FILTER_TYPE = 'showSelected';

export const setShowSelectedFilter = (policies, showSelectedOnly) => {
  policies.removeDiscreteFilter(SHOW_SELECTED_FILTER_TYPE);

  if (showSelectedOnly) {
    policies.setDiscreteFilters([
      ...policies.discreteFilters,
      { type: SHOW_SELECTED_FILTER_TYPE, fn: (model) => model.isSelected }
    ]);
  }

  policies.filter();
};

@observer
class AlertPolicyAssignmentsTab extends Component {
  handleShowSelectedToggle = () => {
    const { policies, showSelectedOnly, onShowSelectedToggle } = this.props;
    const next = !showSelectedOnly;

    setShowSelectedFilter(policies, next);
    onShowSelectedToggle(next);
  };

  get columns() {
    const { isPresetCompany } = this.props;
    return [
      {
        name: 'applicationLabel',
        label: 'Type',
        ellipsis: false,
        flexBasis: 15,
        computed: true
      },
      {
        name: 'name',
        label: isPresetCompany ? 'Name' : 'Policy Name',
        flexBasis: 30,
        ellipsis: false
      },
      {
        name: 'uiProperties.activeAlerts',
        label: '# Active Alerts',
        flexBasis: 15,
        renderer: ({ model }) => {
          const activeAlerts = model.get('uiProperties.activeAlerts');
          return activeAlerts?.length || 0;
        }
      },
      {
        name: 'enabled',
        label: 'Status',
        align: 'center',
        width: 80,
        padding: '4px 0 0 0',
        ellipsis: false,
        computed: true,
        renderer: ({ model, value }) => policyStatusRenderer({ model, value })
      },
      {
        name: 'lastModified',
        label: 'Last Modified',
        value: 'lastModified',
        flexBasis: 15,
        computed: true
      }
    ];
  }

  render() {
    const { policies, showSelectedOnly, readOnly } = this.props;

    return (
      <FlexColumn p={3} height="calc(100% - 80px)">
        {!readOnly && (
          <Flex alignItems="center" justifyContent="flex-end" mb={1}>
            <Switch checked={showSelectedOnly} onChange={this.handleShowSelectedToggle} label="Show Selected" />
          </Flex>
        )}

        <FlexColumn flex={1}>
          {/* admin table search without setting hash in url */}
          <Search
            collection={policies}
            inputProps={{
              ariaLabel: 'Search Table',
              className: 'round chips',
              leftElement: (
                <Flex alignItems="center" maxWidth="1180px">
                  <Icon icon="search" mr="2px" ml="-6px" color="muted" />
                </Flex>
              )
            }}
            mx="3px"
            mb={1}
          />
          <AdminTable
            flexed
            collection={policies}
            columns={this.columns}
            searchBar={false}
            multiSelect={!readOnly}
            multiSelectProps={{ verticalAlign: 'center' }}
            hideHeader={false}
            fetchCollectionOnMount={false}
            tableContainerProps={{
              bg: 'cardBackground'
            }}
          />
        </FlexColumn>
      </FlexColumn>
    );
  }
}

export default AlertPolicyAssignmentsTab;
